import { atom } from 'recoil';

import { EmissionsFormInputsInterface } from '@/types';
import { EmissionsCalculationApiResponse } from '@/types/api-response-types';

export const emissionsCalculatorEditingSegmentIndexState = atom<number | null>({
  key: 'emissionsCalculatorEditingSegmentIndexState',
  default: null,
});

export const emissionsCalculatorResultsWarningsState = atom<boolean>({
  key: 'emissionsCalculatorResultsWarningsState',
  default: false,
});

// Atom to track when to trigger the emissions calculation
export const emissionsTriggerCalculation = atom<number>({
  key: 'emissionsTriggerCalculation',
  default: 0,
});

// Controls whether segments should be automatically appended when a location
// is added. Useful for loading data directly into the form state
export const emissionsCalculatorAutoAppendEnabledState = atom<boolean>({
  key: 'emissionsCalculatorAutoAppendEnabledState',
  default: true,
});

export const emissionsCalculatorResultsState = atom<EmissionsCalculationApiResponse | null>({
  key: 'emissionsCalculatorResultsState',
  default: null,
});

// @NOTE: Currently only used for loading initial values from an
// emissions summary elsewhere in the app, like a route itinerary

// @TODO: Consider this being the source of truth for the form data
export const emissionsCalculatorFormState = atom<EmissionsFormInputsInterface | null>({
  key: 'emissionsCalculatorFormState',
  default: null,
});
